module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountLicenses)
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-left": "",
      "justify-center": ""
    }
  }, [_vm._l((_vm.topItems), function(item) {
    return [_c('v-flex', {
      attrs: {
        "px-2": ""
      }
    }, [_c('b', [(!_vm.getImageUrl(item)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v(_vm._s(item.registrationNumber))]) : _vm._e()]), _vm._v(" "), _c('b', [(_vm.getImageUrl(item) && item.sound) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v("Звук"), _c('br'), _vm._v(" " + _vm._s(item.registrationNumber))]) : _vm._e()]), _vm._v(" "), (_vm.getImageUrl(item) && !item.sound) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "120px"
      },
      attrs: {
        "src": _vm.getImageUrl(item)
      }
    })]) : _vm._e()])]
  })], 2)], 1)]), _vm._v(" "), (_vm.isLoaded && _vm.lastItems.length > 0) ? _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_vm._l((_vm.lastItems), function(item) {
    return [_c('v-flex', {
      attrs: {
        "px-2": ""
      }
    }, [_c('b', [(!_vm.getImageUrl(item)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v(_vm._s(item.registrationNumber))]) : _vm._e()]), _vm._v(" "), (_vm.getImageUrl(item)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [(_vm.getImageUrl(item)) ? _c('img', {
      staticStyle: {
        "max-height": "120px"
      },
      attrs: {
        "src": _vm.getImageUrl(item)
      }
    }) : _vm._e()]) : _vm._e()])]
  })], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00813ab9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/TrademarksPanel.vue
// module id = 1068
// module chunks = 1